/* global window, document, location, console */
import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import Modal from "./Modal";
import Heroicon from "./Heroicon";

function SendInvite() {
  let [isOpen, setIsOpen] = useState(false);
  let [inviteEmail, setInviteEmail] = useState(null);
  let [isThereError, setIsThereError] = useState(false);
  let [isThereSuccess, setIsThereSuccess] = useState(false);

  function closeModal() {
    setIsOpen(false);
    setIsThereError(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  function sendInvite(e) {
    e.preventDefault();

    window.axios
      .post("/api/v2/team-members", {
        email: inviteEmail,
      })
      .then(function (response) {
        if (response.status === 201) {
          setIsThereSuccess(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.status === 422) {
          setIsThereError(true);
        }
      });
  }

  return (
    <>
      <button
        className="flex items-center gap-1 text-sm btn-solid btn-primary sm:text-base"
        onClick={openModal}
      >
        <Heroicon icon="o-plus" style="text-purple-100 w-5 h-5" />
        Add Member
      </button>

      {!isThereSuccess ? (
        <Modal
          title="Invite new team member"
          isOpen={isOpen}
          closeModal={closeModal}
        >
          <form method="POST" onSubmit={(e) => sendInvite(e)}>
            <div className="px-6 py-4">
              <label htmlFor="email" className="block text-gray-800">
                Email
              </label>
              <input
                name="email"
                type="email"
                onChange={(e) => {
                  setInviteEmail(e.target.value);
                  // Remove error message and styles when the field is updated
                  setIsThereError(false);
                }}
                className={`input bg-gray-50 ${
                  isThereError ? "input--danger" : ""
                }`}
              />
              {isThereError && (
                <p className="mt-2 text-sm text-red-700">
                  This email is already connected to a Castos account. To invite
                  the team member, enter a different email address.
                </p>
              )}
            </div>

            <div className="flex flex-wrap justify-between gap-2 px-6 py-4 mt-6 bg-gray-200">
              <button
                className="inline-block btn-solid btn-primary"
                id="send-invite"
              >
                Send Invite
              </button>

              <button
                type="button"
                onClick={closeModal}
                className="inline-block btn-solid btn-dark"
              >
                Close
              </button>
            </div>
          </form>
        </Modal>
      ) : (
        <Modal
          title="Invite new team member"
          isOpen={true}
          closeModal={() => location.reload()}
        >
          <div className="flex-col p-4 m-4 text-sm rounded-md sm:text-base alert alert--success">
            <Heroicon
              icon="o-check-circle"
              style="mr-3 w-12 h-12 sm:w-16 sm:h-16 text-green-600"
            />
            <p className="mt-4">Invitation sent!</p>
            <p>{inviteEmail}</p>
          </div>
          <div className="flex justify-end px-6 py-4 mt-6 bg-gray-200">
            <button
              className="btn-solid btn-dark"
              onClick={() => location.reload()}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
    </>
  );
}

const initSendInvite = function (selector) {
  const elements = document.querySelectorAll(selector);
  if (elements.length > 0) {
    elements.forEach((element) => {
      const root = createRoot(element);
      root.render(<SendInvite />);
    });
  }
};

export { SendInvite as default, initSendInvite };
